<template>
  <div class="container">
    <titular />
    <div class="row mb-3">
      <div class="col-12">
        <ul class="list-inline">
          <li class="list-inline-item">
            <button class="btn btn-primary" @click="crearBackup" :disabled="loading.creacionBackup"><i class="fa-solid fa-plus"></i> Crear còpia de seguretat</button>
          </li>
          <li class="list-inline-item">
            <button class="btn btn-secondary" @click="subirBackup" :disabled="loading.subirBackup"><i class="fa-solid fa-upload"></i> Pujar + restaurar</button>
          </li>
        </ul>
      </div>
    </div>
    <div class="row" v-if="backups.length">
      <ul class="list-group list-group-flush col-12 col-md-6 mx-auto">
        <li v-for="(backup, index) in backups" :key="index" class="list-group-item d-flex justify-content-between align-items-center">
          {{ backup }}
          <div>
            <ul class="list-inline">
              <li class="list-inline-item">
                <button class="btn btn-secondary btn-sm" data-toggle="modal" :data-target="`#modal-restaurar-${index}`" title="Restaurar còpia de seguretat" v-tooltip><i class="fa-solid fa-arrow-up-from-bracket"></i></button>
              </li>
              <li class="list-inline-item">
                <button class="btn btn-secondary btn-sm" title="Descarregar còpia de seguretat" @click="descargarBackup(backup)" :disabled="loading.download" v-tooltip><i class="fa-solid fa-download"></i></button>
              </li>
            </ul>
            <modal :ref="`modalRestauracion${index}`" titulo="Restaurar còpia de seguretat" icono="fa-solid fa-arrow-up-from-bracket" btnClass="btn-secondary" :hayLanzador="false" :modalId="`restaurar-${index}`" :loading="loading.restaurarBackup">
              <template v-slot:body>
                <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
                Vols restaurar la copia <b>{{ backup }}</b>?
              </template>
              <template v-slot:footer>
                <button type="submit" class="btn btn-danger" :disabled="loading.restaurarBackup" @click="restaurarBackup(index, backup)"><i-submit icono="fa-trash-can" :loading="loading.restaurarBackup" />Confirmar</button>
              </template>
            </modal>
          </div>
        </li>
      </ul>
    </div>
    <vacio v-else>No hi ha cap còpia de seguretat.</vacio>
  </div>
</template>
      
<script>
export default {
  name: "",
  data() {
    return {
      loading: {
        creacionBackup: false,
        restaurarBackup: false,
        download: false,
      },
      backups: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http.get("api/backups").then((response) => (this.backups = Object.values(response.data).reverse()));
    },
    crearBackup() {
      this.loading.creacionBackup = true;
      this.$http.post("api/backups")
        .then(response => {
          this.$toast.clear();

          if (response.data?.error) {
            this.$toast.open({ type: "error", position: "top", duration: 0, message: response.data.error });
          } else {
            this.$toast.open({ position: "top", message: `Còpia de seguretat creada correctament.` });

            this.getData();
          }
        })
        .finally(() => this.loading.creacionBackup = false);
    },
    descargarBackup(arxiu) {
      this.loading.download = true;

      this.$http.get(`api/backups?${new URLSearchParams({ arxiu })}`)
        .then(response => {
          if (response.status != 200 || (response.response && response.response.status != 200)) return;

          const file = new File([response.data], arxiu);
          const link = document.createElement('a');

          link.href = window.URL.createObjectURL(file);
          link.download = arxiu;

          link.click();

          this.loading.download = false;
        });
    },
    subirBackup() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = ".sql";
      input.onchange = e => {
        const formData = new FormData();
        formData.append("sql", e.target.files[0]);

        this.$http
          .post("api/backups", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            if (response.status == 200) {
              this.mostrarMisivaOK();
            }
          });
      }

      input.click();
    },
    restaurarBackup(id, arxiu) {
      this.$http
        .put("api/backups", { arxiu })
        .then(response => {
          if (response.status == 200) {
            this.mostrarMisivaOK();

            this.$refs[`modalRestauracion${id}`][0].cerrar();
          }
        });
    },
    mostrarMisivaOK() {
      this.$toast.open({ position: "top", message: `Còpia de seguretat restaurada correctament, si us plau espera uns segons abans de comprovar les dades.` });
    },
  },
};
</script>
  
<style lang="scss" scoped></style>